import { useCallback, useEffect, useState } from "react";
import { FormikHelpers, useFormikContext } from "formik";
import { add } from "lodash";

export interface SelectableItem extends SelectableItemTyped<number> {
  // id: number | string;
  // value: any;
  // text: string;
  // Add other fields as needed
}

export interface SelectableItemTyped<TId> {
  id: TId;
  value: any;
  text: string;
  // Add other fields as needed
}

interface UseSelectableListOptions<T extends SelectableItemTyped<TId>, TId> {
  formik?: FormikHelpers<any>;
  apiCall: () => Promise<T[]>;
  defaultId?: TId;
  deps?: any[];
  selectFirst?: boolean;
}

export function useSelectableList<T extends SelectableItemTyped<TId>, TId>({
  apiCall,
  defaultId,
  deps = [],
  selectFirst = false
}: UseSelectableListOptions<T, TId>) {
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedId, setSelectedId] = useState<TId | undefined>(defaultId);
  const [selectedItem, setSelectedItem] = useState<T | undefined>(undefined);

  // const formik = useFormikContext();

  const fetchItems = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiCall();
      setItems(data);
    } catch (err: any) {
      setError(err.message || "Unknown error");
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, deps);




  useEffect(() => {
    // if (!selectedId) {
    //  console.log(`${name} Items changed:`, items);
    //  console.log(`${name} Current selectedId:`, selectedId);

    if (defaultId && items.some(item => item.value == defaultId)) {
      // console.log(`${name} Setting selectedId: ${name}`, defaultId);
      setSelectedId(defaultId);
    } else if (selectFirst && items.length > 0) {
      // console.log(`${name} Setting first selectedId: ${name}`, items[0].value);
      setSelectedId(items[0].value);
    } else {
      // console.log(`${name} Setting undefined selectedId:`, undefined);
      setSelectedId(undefined);
    }
    // }
  }, [items]);

  // const selectedItem = items.find(item => item.id === selectedId);

  const onChangeCallback = useCallback(async (_, { value }) => {
    // console.log(`setSelectedId: ${value}`);
    setSelectedId(value);
  }, [setSelectedId]);
  
  useEffect(() => {
    const selected = items.find(item => item.id == selectedId);
    setSelectedItem(selected);
  }, [selectedId, items]);

  useEffect(() => {
    setSelectedId(defaultId);
  }, [defaultId, setSelectedId]);

  return {
    items,
    loading,
    error,
    selectedId,
    setSelectedId,
    selectedItem,
    refresh: fetchItems,
    addItem: (item: T) => setItems(prev => [...prev, item]),
    removeItem: (id: TId) => setItems(prev => prev.filter(i => i.id !== id)),
    getDropdownProps: (overrides?: { onChange?: (event, data) => void }) => ({
      loading: loading,
      options: items,
      onChange: (event, data) => onChangeCallback(event, data).then(() => {
        if (overrides?.onChange) {
          overrides.onChange(event, data);
        }
      }),
      value: selectedId,
    }),
  };
}